import { createSlice } from '@reduxjs/toolkit';
import { ETargetPage, IPage } from '../../types/page';

const initialState: IPage = {
  targetPage: ETargetPage.myHomePage,
};

const pageSlice = createSlice({
  name: 'pageSlice',
  initialState,
  reducers: {
    setPageSource(state, action) {
      state.source = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  reducer: pageReducer,
  actions: { setPageSource },
} = pageSlice;
